import { createStore } from 'owa-satcheljs';

export interface MsalAuthStoreState {
    shouldShowModalDialog: boolean;
    modalDialogShownCount: number;
    isSignInRequired: boolean;
}

export const getStore: () => MsalAuthStoreState = createStore<MsalAuthStoreState>('msalAuthStore', {
    shouldShowModalDialog: false,
    modalDialogShownCount: 0,
    isSignInRequired: false,
});
